import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ResourceStatus } from "@planzone/dto";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Checkbox } from "@common/checkbox";
import { ArrowIcon } from "@common/assets/arrowIcon";

import { Props } from "./types";
import styles from "./styles.scss";

const options: ResourceStatus[] = ["activated", "deactivated"];

// Same dropdown as the WBS "Show" filter: none or both statuses show every resource.
function ResourceStatusFilter({ resourceStatuses, select }: Props) {
  const { t } = useTranslation();
  const isSelected = (status: ResourceStatus) =>
    !!resourceStatuses && resourceStatuses.includes(status);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.resourceStatusFilter}>
          <p className={styles.label}>
            {t("obsPage.filters.resourceStatuses.label")}
          </p>
          <div
            className={classNames(styles.dropdown, {
              [styles.opened]: isVisible,
            })}
          >
            <div className={styles.input} onClick={isVisible ? hide : show}>
              {resourceStatuses && resourceStatuses.length > 0 ? (
                <p className={styles.selectedStatuses}>
                  {resourceStatuses
                    .map((status) =>
                      t(`obsPage.filters.resourceStatuses.${status}`),
                    )
                    .join(", ")}
                </p>
              ) : (
                <p className={styles.placeholder}>
                  {t("obsPage.filters.resourceStatuses.placeholder")}
                </p>
              )}
              <ArrowIcon className={styles.toggleArrow} />
            </div>
            {isVisible && (
              <div className={styles.list}>
                {options.map((option) => (
                  <div
                    key={option}
                    className={classNames(styles.item, {
                      [styles.unchecked]: !isSelected(option),
                    })}
                    onClick={() =>
                      select(
                        isSelected(option)
                          ? (resourceStatuses ?? []).filter(
                              (status) => status !== option,
                            )
                          : [...(resourceStatuses ?? []), option],
                      )
                    }
                  >
                    <Checkbox isChecked={isSelected(option)} />
                    <p className={styles.statusName}>
                      {t(`obsPage.filters.resourceStatuses.${option}`)}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ResourceStatusFilter };
